import ruSlotTranslations from './i18n/ru.json'
import enSlotTranslations from './i18n/en.json'
import ukSlotTranslations from './i18n/uk.json'
import ptSlotTranslations from './i18n/pt.json'
import esSlotTranslations from './i18n/es.json'
import trSlotTranslations from './i18n/tr.json'
import kkSlotTranslations from './i18n/kk.json'
import uzSlotTranslations from './i18n/uz.json'
import idSlotTranslations from './i18n/id.json'
import tgSlotTranslations from './i18n/tg.json'
import kySlotTranslations from './i18n/ky.json'
import arSlotTranslations from './i18n/ar.json'
import faSlotTranslations from './i18n/fa.json'

export const slotResources = {
  ru: ruSlotTranslations,
  en: enSlotTranslations,
  uk: ukSlotTranslations,
  pt: ptSlotTranslations,
  es: esSlotTranslations,
  tr: trSlotTranslations,
  kk: kkSlotTranslations,
  uz: uzSlotTranslations,
  id: idSlotTranslations,
  tg: tgSlotTranslations,
  ky: kySlotTranslations,
  ar: arSlotTranslations,
  fa: faSlotTranslations
}
